/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import PrimaryLogo from 'components/atoms/Logo/Primary';
import ForgotPasswordSubmitForm from 'components/organismos/login/ForgotPasswordSubmitForm';

const styles = {
  formWrapper: css({
    background: '#F2F5F9',
    margin: '3em auto',
    padding: '0 1em',
    maxWidth: '480px',
  }),
  h1: css({
    textAlign: 'center',
    padding: '0 0',
  }),
  h2: css({
    textAlign: 'center',
    padding: '0 0',
  }),
  form: css({
    padding: '0 1.5em',
  }),
  standardLogo: css({
    marginLeft: 'auto',
    marginRight: 'auto',
    verticalAlign: 'middle',
    width: '100px',
    height: '100px',
    padding: '8px 12px',
  }),
};

const ForgotPasswordSubmitPage: React.FC = () => (
  <div css={styles.formWrapper}>
    <div css={styles.h1}>
      <PrimaryLogo css={styles.standardLogo} />
    </div>
    <h2 css={styles.h2}>パスワード変更</h2>
    <ForgotPasswordSubmitForm />
  </div>
);

export default ForgotPasswordSubmitPage;
